import React from "react";
import { colors } from "@ui/Theme";
import t from "../../../../../../../../../i18n";
import { type BlockPresetImportT } from "../../../../../../schema/block/preset";
import Dashboard2Line from "@ui/IconV2/react/Dashboard2Line";

export const icon = () => <Dashboard2Line size="l" color={colors.carbon800} />;

export const title = t("project.dashboard.block.template.production-monitoring-preset.title");

export const description = null;

export const block: Omit<BlockPresetImportT, "dashboardId" | "position"> = {
  kind: "PRESET",
  data: {
    title,
    preset: "PRODUCTION_MONITORING",
  },
};
